
import React from 'react';
import { InputContainer } from '../../components/form/form.module';

export const BillingAddressComponent = ({libraries,countries,isAddress, onInnerFormChange, selectBillingAddress, stateValues, onFilterToStates }: any) => (<>
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Address1"
                    name="Address1"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.Address1',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.Address1}
                />
          <InputContainer
                    label="Address2"
                    name="Address2"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.Address2',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.Address2}
                />
            <InputContainer
                    label="City"
                    name="City"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.City',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.City}
                />
            <InputContainer
          
          label="Country Name"
          labelField="Name"
          list={countries}
          onValueChange={(event: any) => {
            onFilterToStates(event.target.value);
           
          }}
          optionName='Choose Country'
          type="select"
          value={selectBillingAddress?.BillingAddress?.CountryId}
          valueField="Id"
      />
                
            <InputContainer
          
          label="State Name"
          labelField="Name"
          list={stateValues}
          onValueChange={(event: any) => {
            onInnerFormChange(
                event.target.value,
                'BillingAddress.StateProvinceId',
                selectBillingAddress?.BillingAddress
              );
          }}
          optionName='Choose State'
          type="select"
          value={selectBillingAddress?.BillingAddress?.StateProvinceId}
          valueField="Id"
      />
                
          <InputContainer
                    label="ZipPostalCode"
                    name="ZipPostalCode"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.ZipPostalCode',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.ZipPostalCode}
                />
            
            { isAddress
              ? <>
           
                <InputContainer
                    label="FaxNumber"
                    name="FaxNumber"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.FaxNumber',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="number"
                    value={selectBillingAddress?.BillingAddress?.FaxNumber}
                />
           <InputContainer
            label="OpeningHours Type"
            labelField="Description"
            list={libraries.OpeningHoursType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'BillingAddress.OpeningHoursTypeId',
                selectBillingAddress?.BillingAddress
              );
            }}
            optionName='Choose OpeningHoursType'
            type="select"
            value={selectBillingAddress?.BillingAddress?.OpeningHoursTypeId}
            valueField="Value"
        />
     <InputContainer
                    label="Geocode Accuracy"
                    name="GeocodeAccuracy"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.GeocodeAccuracy',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.GeocodeAccuracy}
                />
           <InputContainer
                    label="Latitude"
                    name="Latitude"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.Latitude',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.Latitude}
                />
            <InputContainer
                    label="Longitude"
                    name="Longitude"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'BillingAddress.Longitude',
                        selectBillingAddress?.BillingAddress
                      )
                    }}
                    type="text"
                    value={selectBillingAddress?.BillingAddress?.Longitude}
                />
           
            </>
              : null}
       </div>

    </>
)
